<template>
  <v-app v-if="articleInfoValue">
    <v-container fluid class="article-actions">
      <v-row>
        <v-col cols="2">
          <v-subheader>عنوان</v-subheader>
        </v-col>
        <v-col cols="8">
          <v-text-field
            class="subtitle-1"
            placeholder="عنوان"
            v-model="title"
          ></v-text-field>
        </v-col>
      </v-row>
      <v-row>
        <v-col cols="2">
          <v-subheader>توضیح کوتاه</v-subheader>
        </v-col>
        <v-col cols="8">
          <v-text-field
            placeholder="توضیح کوتاه"
            v-model="shortDescription"
          ></v-text-field>
        </v-col>
      </v-row>
      <v-row>
        <v-col cols="2">
          <v-subheader>لینک</v-subheader>
        </v-col>
        <v-col cols="8">
          <!-- <v-text-field placeholder="شهر" v-model="geoDivisionId"></v-text-field> -->
          <v-text-field placeholder="لینک" v-model="link"></v-text-field>
        </v-col>
      </v-row>
      <v-row>
        <v-col cols="2">
          <v-subheader>تصویر</v-subheader>
        </v-col>
        <v-col cols="8">
          <input type="file" @change="onFileSelected" />
          <img :src="icon" height="200" alt="" />
        </v-col>
      </v-row>
      <v-row>
        <v-col cols="2">
          <v-subheader>توضیح</v-subheader>
        </v-col>
        <v-col cols="8">
          <!-- <v-text-field placeholder="شهر" v-model="geoDivisionId"></v-text-field> -->
          <ckeditor
            placeholder="پاسخ"
            v-model="description"
            :config="editorConfig"
          ></ckeditor>
        </v-col>
      </v-row>
      <v-row justify="center">
        <v-btn
          class="ml-4 white--text font-weight-bold pink darken-1"
          @click="editHandler"
        >
          ثبت کردن
        </v-btn>
        <router-link to="/faq">
          <v-btn class="white--text font-weight-bold indigo lighten-2">
            انصراف
          </v-btn>
        </router-link>
      </v-row>
    </v-container>
  </v-app>
</template>

<script>
import axios from "axios";
import { mapGetters } from "vuex";
export default {
  data() {
    return {
      id: null,
      title: "",
      description: "",
      icon: "",
      shortDescription: "",
      editorConfig: {
        versionCheck: false,
      },
      link: "",
    };
  },
  computed: {
    ...mapGetters(["tokenValue", "articleInfoValue"]),
  },
  methods: {
    onFileSelected(event) {
      this.icon = event.target.files[0];
    },
    async editHandler() {
      await axios
        .post(
          "http://api.karaclub.com/api/SocialMedia/Add",
          {
            title: this.title,
            description: this.description,
            shortDescription: this.shortDescription,
            link: this.link,
          },
          {
            headers: {
              Authorization: `Bearer ${sessionStorage.getItem("token")}`,
            },
          }
        )
        .then((response) => {
          this.id = response.data.data.id;
          const fd = new FormData();
          fd.append("image", this.icon);
          axios
            .post(
              `http://api.karaclub.com/api/SocialMedia/UploadImage?id=${this.id}`,
              fd,
              {
                headers: {
                  Authorization: `Bearer ${sessionStorage.getItem("token")}`,
                  "Content-Type": "multipart/form-data",
                },
              }
            )
            .then(() => {
              this.$router.push("/social-media");
            });
        });
    },
  },
};
</script>

<style>
.article-actions {
  background: #ffffff;
  height: auto;
}
.v-input__control {
  direction: ltr;
}
.v-input__slot {
  flex-direction: row-reverse;
}
.v-application--wrap {
  min-height: auto !important;
}
.theme--light.v-input input {
  text-align: right;
}
.theme--light.v-subheader {
  font-weight: 900;
  font-size: 14px;
}
</style>
